import React from 'react';
import styled from 'styled-components';
import ExpertImg from '../../../Assets/Talk-to-an-Expert.png';

const AvatarContainer = styled.div`
    width: 100px;
    height: 100px;
`;

const AvatarImg = styled.img`
    object-fit: contain;
    transform: scaleX(-1);
    width: 100px;
    height: 100px;
`;
const BotAvatar = () => {
    return (
        <AvatarContainer>
            <AvatarImg src={ExpertImg} helperTxt="avatar" />
        </AvatarContainer>
    );
};

export default BotAvatar;
